/* eslint-disable unicorn/filename-case */
import { Lightbulb02 } from '@untitled-ui/icons-react';

import { Button } from '../../../components/buttons/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogTitle,
} from '../../../components/dialog';
import { FeaturedIcon } from '../../../components/featured-icon';
import { tNamespace } from '../../../services/translation';

const t = tNamespace('app.blogs.-brand-not-filled-modal');

export function BrandNotFilledModal({
  open,
  onOpenChange,
  createAnyway,
  addBrandContext,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  createAnyway: () => void;
  addBrandContext: () => void;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent hasCloseButton>
        <FeaturedIcon icon={<Lightbulb02 />} color="accent" size="md" className="m-auto mb-6" />
        <DialogTitle className="mb-1" align="center">
          {t('title')}
        </DialogTitle>
        <DialogDescription align="center">{t('description')}</DialogDescription>
        <DialogFooter className="flex flex-col gap-4">
          <Button variant="outline" className="w-full" size="xl" onClick={createAnyway}>
            {t('createAnyway')}
          </Button>
          <Button variant="accent" className="w-full" size="xl" onClick={addBrandContext}>
            {t('addBrandContext')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
